import { QueryClient } from '@tanstack/react-query'
import { createMutationCacheWithErrorBackstop } from '@/lib/mutationErrorBackstop'
import { isSearchRequest, isSupportSessionBlocked } from '@/lib/supportSessionErrors'

// Shared QueryClient singleton. It lives in a module (rather than inline in
// main.tsx) so non-React callers can read/seed the cache without a hook or a
// provider — e.g. useFormTelemetry seeds the coach suggestion after an
// abandoned-form ping. main.tsx passes this same instance to QueryClientProvider.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 1, // 1 minute
      // EP-160: a support session refusal is final, so it is not retried.
      retry: (failureCount, error) => failureCount < 1 && !isSupportSessionBlocked(error),
      // EP-160 S3: a page whose data a FlowRent support session may not read
      // (403 support_session_blocked) throws to MainLayout's
      // SupportSessionBlockedBoundary, which shows the blocked page. A refused
      // search does not: it refuses the search, not the page. An ordinary
      // sign-in never gets that code.
      throwOnError: (error) => isSupportSessionBlocked(error) && !isSearchRequest(error),
    },
  },
  // WEB-H6: any failed mutation that no local handler surfaces gets a
  // translated error toast (see mutationErrorBackstop.ts for the dedup rules).
  mutationCache: createMutationCacheWithErrorBackstop(),
})
